import React, { useState } from "react";
import { motion } from 'framer-motion';
import CreditrustPanel from '../CreditrustPanel';
import LegalAnalysisPanel from './LegalAnalysisPanel';
import FinancialStatementsAnalysisPanel from './FinancialStatementsAnalysisPanel';
import CapPagoAnalysisPanel from './CapPagoAnalysisPanel';
import BuroAnalysisPanel from './BuroAnalysisPanel';
import ValidacionIAView from '../ValidacionIA/ValidacionIAView';
import { OcularVisitInline } from './OcularVisitInline';

export const MesaControlPanel = ({ persona, toast, dataBuro, categories = {}, onOcularSuccess, processId, ocularStepStatus, ocularStepData, onVerDocumento }) => {
    const [analysisDirty, setAnalysisDirty] = useState(false);
    const [activeTab, setActiveTab] = useState('validacion_ia');

    const isPM = persona && (persona.selectedTypePerson === 2 || persona.tipo_persona === 'PM' || persona.typePerson === 2 || persona.company);
    const isPFOnly = persona?.persona_subtype === 'PF';

    const isActive = (tabName) => activeTab === tabName;

    const tabStyle = (tabName, activeColor = '#7B1FA2') => ({
        background: isActive(tabName) ? activeColor : 'transparent',
        border: isActive(tabName) ? 'none' : '1px solid #d1d5db',
        padding: '0.3rem 0.7rem',
        cursor: 'pointer',
        fontSize: '0.75rem',
        fontWeight: isActive(tabName) ? '600' : '500',
        color: isActive(tabName) ? '#fff' : '#64748b',
        borderRadius: '16px',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    });

    return (
        <div className="flex flex-column gap-2">
            {/* Tab bar */}
            <div className="flex gap-2 align-items-center flex-wrap" style={{ padding: '0.25rem 0' }}>
                <button onClick={() => setActiveTab('validacion_ia')} style={tabStyle('validacion_ia', '#00796B')}>
                    <i className="pi pi-sparkles mr-1" style={{ fontSize: '0.7rem' }} />
                    Análisis IA
                </button>
                {!isPFOnly && (
                    <button onClick={() => setActiveTab('creditrust')} style={tabStyle('creditrust')}>
                        <i className="pi pi-shield mr-1" style={{ fontSize: '0.7rem' }} />
                        Creditrust
                    </button>
                )}
                <button onClick={() => setActiveTab('buro')} style={tabStyle('buro', '#1565C0')}>
                    <i className="pi pi-check-circle mr-1" style={{ fontSize: '0.7rem' }} />
                    Buró de Crédito
                </button>
                {isPM && (
                    <button onClick={() => setActiveTab('legal')} style={tabStyle('legal')}>
                        <i className="pi pi-building mr-1" style={{ fontSize: '0.7rem' }} />
                        Legal
                    </button>
                )}
                <button onClick={() => setActiveTab('cap_pago')} style={tabStyle('cap_pago')}>
                    <i className="pi pi-wallet mr-1" style={{ fontSize: '0.7rem' }} />
                    Cap. Pago
                </button>
                {isPM && (
                    <button onClick={() => setActiveTab('edos_financieros')} style={tabStyle('edos_financieros')}>
                        <i className="pi pi-percentage mr-1" style={{ fontSize: '0.7rem' }} />
                        Edos Financieros
                    </button>
                )}
                <button onClick={() => setActiveTab('visita_ocular')} style={tabStyle('visita_ocular')}>
                    <i className="pi pi-map-marker mr-1" style={{ fontSize: '0.7rem' }} />
                    Visita Ocular
                </button>
            </div>

            {/* Tab content — Visita Ocular vive fuera para preservar su estado al cambiar de chip */}
            {activeTab !== 'visita_ocular' && (
            <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
            >
                {activeTab === 'validacion_ia' && (
                    <div className="bg-white border-round shadow-1 h-full">
                        <ValidacionIAView
                            categories={categories}
                            persona={persona}
                            onVerDocumento={onVerDocumento}
                            onAnalysisDirty={() => setAnalysisDirty(true)}
                        />
                    </div>
                )}

                {activeTab === 'creditrust' && !isPFOnly && (
                    <CreditrustPanel persona={persona} toast={toast} compact />
                )}

                {activeTab === 'legal' && (
                    <LegalAnalysisPanel
                        persona={persona}
                        toast={toast}
                        dirty={analysisDirty}
                        onDirtyReset={() => setAnalysisDirty(false)}
                    />
                )}

                {activeTab === 'cap_pago' && (
                    <CapPagoAnalysisPanel
                        persona={persona}
                        toast={toast}
                        dirty={analysisDirty}
                        onDirtyReset={() => setAnalysisDirty(false)}
                    />
                )}

                {activeTab === 'edos_financieros' && (
                    <FinancialStatementsAnalysisPanel
                        persona={persona}
                        toast={toast}
                        dirty={analysisDirty}
                        onDirtyReset={() => setAnalysisDirty(false)}
                    />
                )}

                {activeTab === 'buro' && (
                    <BuroAnalysisPanel
                        persona={persona}
                        toast={toast}
                        dataBuro={dataBuro}
                    />
                )}
            </motion.div>
            )}

            {/* Visita Ocular siempre montado para preservar el draft del usuario */}
            <div style={{ display: activeTab === 'visita_ocular' ? 'block' : 'none' }}>
                <OcularVisitInline
                    persona={persona}
                    stepStatus={ocularStepStatus}
                    stepData={ocularStepData}
                    onSuccess={onOcularSuccess}
                    toast={toast}
                    processId={processId}
                />
            </div>
        </div>
    );
};
